import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './payment-worldpay.component'

let module = angular.module('paymentWorldpay', [
  uiRouter
])

.filter('cardSubstring', () => {
  return (card) => {
    let res = card.substring(0, card.indexOf('-')) // EX: VISA-SSL
    return (res)
  }
})

.component('paymentWorldpay', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/payment-worldpay/index.js